import { useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactHCaptcha from '@hcaptcha/react-hcaptcha';

const HCaptcha = ({ siteKey, handleTokenVerify, recaptchaRef }) => {
  const hCaptchaRef = useRef(null);

  useImperativeHandle(recaptchaRef, () => ({
    reset: () => hCaptchaRef.current?.resetCaptcha()
  }));

  return (
    <ReactHCaptcha
      ref={hCaptchaRef}
      sitekey={siteKey}
      onVerify={handleTokenVerify}
      onExpire={() => handleTokenVerify('')}
    />
  );
};

HCaptcha.propTypes = {
  siteKey: PropTypes.string,
  handleTokenVerify: PropTypes.func,
  recaptchaRef: PropTypes.object
};

export default HCaptcha;
